import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-cabinet-unit-heater-controls',
    templateUrl: './cabinet-unit-heater-controls.component.html',
    styleUrls: ['./cabinet-unit-heater-controls.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class CabinetUnitHeaterControlsComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  controlVoltageSelection!: GuruEntity;
  terminalStripSelection!: GuruEntity;
  thermostatTypeSelection!: GuruEntity;
  skyportServiceSelection!: GuruEntity;
  thermostatLocationSelection!: GuruEntity;
  controlDoorSelection!: GuruEntity;
  serviceSwitchSelection!: GuruEntity;
  doorCamlocksSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.CONTROLS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.controlVoltageSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USControlVoltage');
    this.terminalStripSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USTermStrip');
    this.thermostatTypeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USThermostat');
    this.skyportServiceSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSkyportSetupService');
    this.thermostatLocationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USTstatMountLocation');
    this.controlDoorSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USAccessDoorOption');
    this.serviceSwitchSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USServSw');
    this.doorCamlocksSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USDoorCam');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
